import * as React from "react";
const SvgPieChart01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.587 1.881a1.035 1.035 0 0 1 .827 1.898A8.966 8.966 0 0 0 9.419 20.58a8.966 8.966 0 0 0 10.838-5.094 1.035 1.035 0 0 1 1.907.806A11.036 11.036 0 1 1 7.587 1.881m4.45-.833c.36-.108.715-.058.845-.048a11.04 11.04 0 0 1 9.313 6.777A11 11 0 0 1 23 11.119c.012.148.076.59-.105 1a1.56 1.56 0 0 1-.674.732 1.5 1.5 0 0 1-.6.172c-.141.013-.3.012-.42.012h-8.4c-.123 0-.278 0-.413-.01a1.5 1.5 0 0 1-.584-.157 1.54 1.54 0 0 1-.671-.671 1.5 1.5 0 0 1-.157-.584c-.012-.136-.01-.29-.01-.413V2.8c0-.12-.001-.28.011-.42.015-.158.05-.375.172-.6l.066-.108c.162-.246.397-.449.666-.567zm.998 9.917h7.87a8.97 8.97 0 0 0-2.565-5.304 8.97 8.97 0 0 0-5.305-2.567z"
}));
export default SvgPieChart01;
//# sourceMappingURL=PieChart01.js.map